import { render, staticRenderFns } from "./Portfolio_waitlist.vue?vue&type=template&id=3c8e730c&scoped=true&"
import script from "./Portfolio_waitlist.vue?vue&type=script&lang=js&"
export * from "./Portfolio_waitlist.vue?vue&type=script&lang=js&"
import style0 from "./Portfolio_waitlist.vue?vue&type=style&index=0&id=3c8e730c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8e730c",
  null
  
)

export default component.exports